import type { FC } from "react";
import { Masthead, Heading, Button } from "@uhg-harmony/react";
import { useAuth } from "react-oidc-context";
import { StyledButtonWrapper } from "../../ui/wrappers/StoryWrapper";
import { buttonDefaults } from "../../ui/Button";
import "../styles/library.css";

const buttonProps = buttonDefaults;

type AuthProfile = {
  name?: string;
  given_name?: string;
  family_name?: string;
  preferred_username?: string;
  email?: string;
};

const getInitials = (displayName: string) =>
  displayName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "U";

const getDisplayName = (profile?: AuthProfile) =>
  profile?.name ||
  [profile?.given_name, profile?.family_name].filter(Boolean).join(" ") ||
  profile?.preferred_username ||
  "User";

const getEmail = (profile?: AuthProfile) => profile?.email || "";

const buildUserMenuValues = (profile?: AuthProfile, onSignOut?: () => void) => {
  const displayName = getDisplayName(profile);
  const email = getEmail(profile);

  return {
    displayName,
    initials: getInitials(displayName),
    email,
    menuItems: [
      {
        id: "profile",
        label: "My profile",
        clickHandler: () => {},
      },
      {
        id: "notifications",
        label: "Notification preferences",
        clickHandler: () => {},
      },
    ],
    onSignOut: onSignOut ?? (() => {}),
  };
};

const UNAUTHENTICATED_USER_MENU_VALUES = buildUserMenuValues();

export interface TemplateLibraryHeaderProps {
  onBack?: () => void;
}

export const TemplateLibraryHeader: FC<TemplateLibraryHeaderProps> = ({
  onBack,
}) => {
  const auth = useAuth();

  const mastheadProps = {
    productSwitcherValues: undefined,
    clientSwitcherValues: undefined,
    userMenuValues: auth.user?.profile
      ? buildUserMenuValues(auth.user.profile, () => auth.signoutRedirect?.())
      : UNAUTHENTICATED_USER_MENU_VALUES,
    notificationMenuValues: undefined,
  };

  return (
    <>
      <Masthead {...mastheadProps} />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          position: "relative",
        }}
      >
        <StyledButtonWrapper
          style={{
            display: "flex",
            justifyContent: "flex-start",
            position: "absolute",
            left: 100,
            marginTop: "0px",
          }}
        >
          <Button
            {...buttonProps}
            size="m"
            variant="secondary"
            onPress={onBack}
          >
            Back
          </Button>
        </StyledButtonWrapper>

        <Heading
          style={{ textAlign: "center", width: "100%", marginTop: "15px" }}
        >
          Template Library
        </Heading>
      </div>
    </>
  );
};
